import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface DashboardCardRowProps {
    title: string;
    value: ReactNode;
}

export default function DashboardCardRow({ title, value }: DashboardCardRowProps) {
    return (
        <Box 
            sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                width: '100%',
                mb: 1,
                '&:last-child': {
                    mb: 0
                }
            }}
        >
            <Typography 
                variant="body1" 
                color="text.secondary"
                sx={{ 
                    textAlign: 'left',
                    flex: '1 1 auto'
                }}
            >
                {title}
            </Typography>
            <Typography 
                variant="body1"
                sx={{ 
                    textAlign: 'right',
                    ml: 2,
                    flex: '0 0 auto'
                }}
            >
                {value}
            </Typography>
        </Box>
    );
} 